'use strict';

var Colors = {};

// see: http://stackoverflow.com/a/5624139

Colors.rgbToString = function (r, g, b) {
    r = parseInt(r);
    g = parseInt(g);
    b = parseInt(b);
    return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
};

Colors.stringToRgb = function (hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
};

module.exports = Colors;
